export const CREATE_STUDENT_URL = '/students/students';
export const FETCH_STUDENT_URL = '/students/student';
export const UPDATE_STUDENT_URL = '/students/student';
